<template>
  <div style="position: fixed; z-index:1; width: 860px;">
    <div
      v-for="(expense, expenseIndex) in currentPoliticalAction.memory.expenses"
      :key="expenseIndex"
    >
      <div
        class="flex justify-between border-bottom border-blue w-full h-fit mt-6"
      >
        <!-- 経費 -->
        <span class="text-blue text-lg font-bold">
          経費{{ expenseIndex + 1 }}/{{
            currentPoliticalAction.memory.expenses.length
          }}
        </span>
        <!-- 総支出 -->
        <span class="flex flex-row text-blue">
          <div>
            <span>{{ makeProratedText(expense) }}</span>
            <span class="mx-0.5">/</span>
            <span class="h-fit text-lg font-bold">総</span>
            <span class="text-sm font-bold">支出</span>
            <span class="text-lg font-bold">{{ totalExpensesText }}</span>
          </div>
        </span>
      </div>
      <app-table v-bind="$attrs" class="ml-3 mr-3 w-full">
        <template v-slot:table-body>
          <tr
            class="border border-collapse border-dashed border-blue border-t-0 border-l-0 border-r-0 h-12"
            style="height:49px; width:828px"
            :style="
              (!expense.receipt.haveReceiptImages &&
                header.title === '債権者住所・氏名') ||
              (expense.receipt.haveReceiptImages && header.title === '領収書')
                ? 'display:none'
                : ''
            "
            v-for="(header, index) in rejectHeaders[expenseIndex]"
            :key="index"
          >
            <template v-if="rejected(header.attr)">
              <td width="185px" style="max-widht:185px;" class="rejected-line">
                <div class="flex flex-row items-center cursor-pointer">
                  <RejectedIcn width="20px" height="20px" class="ml-3 mr-1" />
                  <span
                    class="text-lg text-red font-bold"
                    style="width: 160px;"
                  >
                    {{ header.title }}
                  </span>
                </div>
                <div
                  class="flex flex-row items-center cursor-pointer mt-4"
                  @click="rejectToggleAttr(header)"
                >
                  <RejectCancelIcn class="ml-3 mr-1" />
                  <div class="flex flex-row items-baseline">
                    <span class="text-lg text-red font-bold"> 入力 </span>
                    <span class="text-sm text-red font-bold">
                      を
                    </span>
                    <span class="text-lg text-red font-bold">
                      解除
                    </span>
                  </div>
                </div>
              </td>
              <td class="rejected-line pr-3" style="height: 93px">
                <span
                  class="text-lg text-red block"
                  style="word-wrap: break-word;"
                  :id="`reason-comment-${header.attr}`"
                  @click="showReasonInput(header.attr)"
                  v-show="false"
                >
                  {{
                    header.comment.length
                      ? header.comment
                      : '※ コメントはありません'
                  }}
                </span>
                <AppTextInput
                  color="red"
                  class="text-red"
                  style="width:642px"
                  placeholder="コメントを入力ください"
                  v-model="header.comment"
                  @blur="onBlur(header)"
                  :id="`reason-input-${header.attr}`"
                  v-show="true"
                />
                <br />
                <!-- 差し戻しを押したときの差し戻し入力欄の下に出てくるテキスト -->

                <span class="text-lg" style="word-wrap: break-word;">
                  {{ getExpenseData(header.title, expense) }}
                </span>
              </td>
            </template>
            <template v-else>
              <td width="185px" style="max-widht:185px;">
                <div
                  class="flex flex-row items-center cursor-pointer"
                  @click="rejectToggleAttr(header)"
                >
                  <RejectIcn width="20px" height="20px" class="ml-3 mr-1" />

                  <span
                    v-if="
                      expense.receipt.haveReceiptImages &&
                        header.title === '支出内容'
                    "
                    class="text-lg text-blue font-bold"
                    >内訳</span
                  >
                  <span
                    v-else-if="
                      expense.receipt.haveReceiptImages &&
                        header.title === '補記'
                    "
                    class="text-lg text-blue font-bold"
                    >理由</span
                  >
                  <span
                    class="text-lg text-blue font-bold"
                    style="width: 150px;"
                  >
                    {{ header.title }}
                    <LetterGreen
                      v-if="header.attr == 'officeMessage'"
                      class="pt-1 mr-2 ml-1 mb-2 inline blue-icon"
                      width="18px"
                      height="18px"
                    ></LetterGreen>
                  </span>
                </div>
              </td>
              <td v-if="header.title === '支出内容'" style="max-width:665px">
                <AppPreviewSentBackItem
                  color="blue"
                  :message="
                    getSentBackItemMessage(
                      header.attr
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase(),
                    )
                  "
                />
                <span class="text-lg" style="word-wrap: break-word;">
                  {{ expense.receipt?.expenseContent1 }}
                </span>
              </td>
              <td v-else-if="header.title === '補記'" style="max-width:665px">
                <AppPreviewSentBackItem
                  color="blue"
                  :message="
                    getSentBackItemMessage(
                      header.attr
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase(),
                    )
                  "
                />
                <span class="text-lg" style="word-wrap: break-word;">
                  {{ expense.receipt?.expenseContent2 }}
                </span>
              </td>
              <td
                v-else-if="header.title === '債権者住所・氏名'"
                style="max-width:665px"
              >
                <AppPreviewSentBackItem
                  color="blue"
                  :message="
                    getSentBackItemMessage(
                      header.attr
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase(),
                    )
                  "
                />
                <span class="text-lg" style="word-wrap: break-word;">
                  {{ expense.receipt?.creditorInfo }}
                </span>
              </td>
              <td
                v-else-if="header.title === '領収書'"
                :style="expense.receipt.haveReceiptImages ? 'display:none' : ''"
              >
                <AppPreviewSentBackItem
                  color="blue"
                  :message="
                    getSentBackItemMessage(
                      header.attr
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase(),
                    )
                  "
                />
                <span class="text-lg">
                  <div v-for="(img, index) in expense.image" :key="index">
                    <span :class="`text-red mb-1 ml-1`"
                      >※画像クリックで黒塗りダイアログが開きます</span
                    >
                    <button
                      class="text-white bg-blue mt-2"
                      style="border-radius:5px; height:30px; width:100px;"
                      @click.stop="openImgZoomer(index, expenseIndex)"
                    >
                      <span class="flex flex-row items-center justify-center">
                        ズーム
                      </span>
                    </button>
                    <img
                      class="mt-1"
                      v-if="img.normalImage"
                      :src="
                        img.blackImage == null
                          ? img.normalImage
                          : img.blackImage
                      "
                      @click="
                        openImgPreview('memory', expenseIndex, {
                          normalImage: img.normalImage,
                          blackImage: img.blackImage,
                          index: index,
                        })
                      "
                    />
                    <TransitionRoot
                      appear
                      v-if="
                        isImgZoomerOpen &&
                          imageIndex === index &&
                          expIndex === expenseIndex
                      "
                      as="template"
                    >
                      <Dialog as="div">
                        <div
                          class="fixed inset-0 overflow-y-auto"
                          style="z-index: 400"
                        >
                          <DialogOverlay
                            class="fixed inset-0 bg-black opacity-50"
                          />
                          <AppImageZoomer
                            :source="
                              img.blackImage == null
                                ? img.normalImage
                                : img.blackImage
                            "
                          ></AppImageZoomer>
                        </div>
                      </Dialog>
                    </TransitionRoot>
                  </div>
                </span>
              </td>
              <td
                v-else-if="header.title == '添付資料'"
                class="pt-2 pb-2"
                style="max-width:665px"
              >
                <AppPreviewSentBackItem
                  color="blue"
                  :message="
                    getSentBackItemMessage(
                      header.attr
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase(),
                    )
                  "
                />
                <span class="text-lg">
                  <div
                    v-for="(file, index) in expense.additionalResources"
                    :key="index"
                  >
                    <span
                      class="hover:text-blue
                  "
                      style="cursor: pointer; word-wrap: break-word;"
                      @click="downloadOrPreview(file, expense.receipt.id)"
                    >
                      {{ file.display ? file.display : file.name }}</span
                    >
                  </div>
                </span>
              </td>

              <td v-else>
                <AppPreviewSentBackItem
                  color="blue"
                  :message="
                    getSentBackItemMessage(
                      header.attr
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase(),
                    )
                  "
                />
                <span class="text-lg">
                  {{ getExpenseData(header.title, expense) }} </span
                ><br />
                <span
                  v-if="expense.receipt?.isPartial && header.title === '支払額'"
                >
                  {{ expense.receipt?.partialComment }}
                </span>
              </td>
            </template>
          </tr>
        </template>
      </app-table>
    </div>
    <div class="ml-3 mr-3 mb-5 w-full" style="margin-top:-20px">
      <tr
        class="border border-collapse border-dashed border-blue border-t-0 border-l-0 border-r-0 h-12"
        style="height:49px; width:848px; vertical-align: middle;"
        v-for="(officeMessageHeader, index) in memoryOfficeMessage"
        :key="index"
      >
        <template v-if="rejected(officeMessageHeader.attr)">
          <td width="185px" class="rejected-line">
            <div class="flex flex-row items-center cursor-pointer">
              <RejectedIcn width="20px" height="20px" class="ml-3 mr-1" />
              <span class="text-lg text-red font-bold">
                {{ officeMessageHeader.title }}
              </span>
              <LetterGreen
                v-if="officeMessageHeader.attr == 'officeMessage'"
                class="pt-1 mr-2 ml-1 red-icon"
                width="18px"
                height="18px"
              ></LetterGreen>
            </div>
            <div
              class="flex flex-row items-center cursor-pointer mt-4"
              @click="rejectToggleAttr(officeMessageHeader)"
            >
              <RejectCancelIcn class="ml-3 mr-1" />
              <div class="flex flex-row items-baseline">
                <span class="text-lg text-red font-bold"> 入力 </span>
                <span class="text-sm text-red font-bold">
                  を
                </span>
                <span class="text-lg text-red font-bold">
                  解除
                </span>
              </div>
            </div>
          </td>
          <td class="rejected-line" style="height: 93px; width:678px;">
            <span
              v-if="officeMessageHeader.attr === 'officeMessage'"
              class="text-lg text-red block"
              style="word-wrap: break-word;"
              :id="`reason-comment-${officeMessageHeader.attr}`"
              @click="showReasonInput(officeMessageHeader.attr)"
              v-show="false"
            >
              {{
                officeMessageHeader.comment
                  ? officeMessageHeader.comment
                  : '※ コメントはありません'
              }}
            </span>
            <!-- inputタグだと改行できないためofficeMessageはtextareaを使用する -->
            <textarea
              v-if="officeMessageHeader.attr === 'officeMessage'"
              class="text-red border border-1 border-red resize-none px-4"
              style="width:642px;height: 120px; border-radius: 20px;margin: 10px 0px;"
              placeholder="メッセージを入力ください"
              v-model="officeMessageHeader.comment"
              @blur="onBlur(officeMessageHeader)"
              :id="`reason-input-${officeMessageHeader.attr}`"
              v-show="true"
            ></textarea>
            <br />
          </td>
        </template>
        <template v-else>
          <td width="185px">
            <div
              class="flex flex-row items-center cursor-pointer"
              @click="rejectToggleAttr(officeMessageHeader)"
            >
              <RejectIcn width="20px" height="20px" class="ml-3 mr-1" />
              <span class="text-lg text-blue font-bold">
                {{ officeMessageHeader.title }}
              </span>

              <LetterGreen
                class="pt-1 mr-2 ml-1 blue-icon"
                width="18px"
                height="18px"
              ></LetterGreen>
            </div>
          </td>
          <td>
            <AppPreviewSentBackItem
              color="blue"
              :message="
                getSentBackItemMessage(
                  officeMessageHeader.attr
                    .split(/(?=[A-Z])/)
                    .join('_')
                    .toLowerCase(),
                )
              "
            />
          </td>
        </template>
      </tr>
    </div>
  </div>
</template>

<script>
import {
  nextTick,
  reactive,
  computed,
  getCurrentInstance,
  onMounted,
} from 'vue'

import AppTable from '@/components/ui/AppTable'
import AppTextInput from '@/components/ui/AppTextInput'
import AppPreviewSentBackItem from '@/components/ui/AppPreviewSentBackItem'
import RejectIcn from '@/assets/icons/reject.svg?inline'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import RejectCancelIcn from '@/assets/icons/reject-cancel.svg?inline'
import LetterGreen from '@/assets/icons/letter-green.svg?inline'
import AppImageZoomer from '@/components/ui/AppImageZoomer'
import { TransitionRoot, Dialog, DialogOverlay } from '@headlessui/vue'
import { useImgUploader } from '@/services/useImgUploader'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'
import { useMemoryReject } from '@/services/politicalActionToda/useMemoryReject'
import { useDialog } from '@/services/useDialog'
import { useMemoryForm } from '@/services/politicalActionToda/useMemoryForm'
import { useFileUploader } from '@/services/useFileUploader'

export default {
  name: 'MemoryOffice_TODA',

  components: {
    AppTable,
    AppTextInput,
    AppPreviewSentBackItem,
    RejectIcn,
    RejectedIcn,
    RejectCancelIcn,
    LetterGreen,
    AppImageZoomer,
    Dialog,
    DialogOverlay,
    TransitionRoot,
  },

  setup() {
    let {
      rejectHeaders,
      memoryOfficeMessage,
      rejectedAttrs,
      setRejectHeader,
    } = useMemoryReject()

    let imgPreviewState = reactive({ isShown: false, previewImgSrc: null })
    const {
      isImgZoomerOpen,
      openImgZoomer,
      imageIndex,
      expIndex,
    } = useImgUploader()
    const { currentPoliticalAction, actionTypeNames } = usePoliticalActions()
    const { downloadOrPreviewFromS3 } = useFileUploader()

    const isShowImgPreview = src => {
      imgPreviewState.isShown = true
      imgPreviewState.previewImgSrc = src
    }

    const onBlur = header => {
      let comment = document.getElementById(`reason-comment-${header.attr}`)
      let reasonInput = document.getElementById(`reason-input-${header.attr}`)
      comment.style.display = 'block'
      reasonInput.style.display = 'none'
      header.comment = reasonInput.value
      if (header.attr === 'officeMessage') {
        memoryOfficeMessage[0].comment = reasonInput.value
      } else {
        rejectedAttrs.find(item => item.target == header.attr).comment =
          reasonInput.value
      }
    }

    const rejectToggleAttr = header => {
      const itemIndex = rejectedAttrs.findIndex(
        item => item.target == header.attr,
      )
      if (itemIndex > -1) {
        rejectedAttrs.splice(itemIndex, 1)
        header.comment = ''
        // headers.find((item) => item.attr == attr).comment = "";
      } else {
        rejectedAttrs.push({
          target: header.attr,
          comment: '',
        })
        nextTick(() => {
          document.getElementById(`reason-input-${header.attr}`).focus()
        })
      }
    }

    const rejected = attr => {
      return rejectedAttrs.findIndex(item => item.target == attr) > -1
    }

    const showReasonInput = attr => {
      let comment = document.getElementById(`reason-comment-${attr}`)
      let reasonInput = document.getElementById(`reason-input-${attr}`)
      comment.style.display = 'none'
      reasonInput.style.display = 'block'
      reasonInput.focus()
    }

    onMounted(() => {
      for (let i = 0; i < currentPoliticalAction.memory.expenses.length; i++) {
        if (!rejectHeaders[i]) {
          rejectHeaders.push(setRejectHeader(i))
          rejectHeaders[i].forEach(rejectHeader => {
            rejectHeader.attr = rejectHeader.attr + (i + 1)
          })
        }
      }
    })

    /**
     * 充当額または按分したテキストを返す
     *
     * @param {object} expense
     * @returns string
     */
    const makeProratedText = expense => {
      const amount = expense?.receipt?.expenseAmount ?? 0
      const numerator = expense?.receipt?.numerator ?? 0
      const denominator = expense?.receipt?.denominator ?? 0
      const partialAmount = expense?.receipt?.partialAmount ?? 0
      let proratedAmount = amount
      if (expense?.receipt?.isPartial && partialAmount !== 0) {
        proratedAmount = partialAmount
      } else if (
        expense?.receipt?.isDistributed &&
        !(amount === 0 || numerator === 0 || denominator === 0)
      ) {
        proratedAmount = prorate(amount, numerator, denominator)
      }
      return `${proratedAmount.toLocaleString()}円`
    }

    const expenses = computed(() => {
      return currentPoliticalAction.memory.expenses
    })

    /**
     * @var {number} 支出総額
     */
    const totalExpenses = computed(() => {
      return expenses.value.reduce((total, expense) => {
        const amount = expense?.receipt?.expenseAmount ?? 0
        const numerator = expense?.receipt?.numerator ?? 0
        const denominator = expense?.receipt?.denominator ?? 0
        const partialAmount = expense?.receipt?.partialAmount ?? 0
        if (amount === 0) {
          return total
        } else if (expense?.receipt?.isPartial && partialAmount !== 0) {
          return total + partialAmount
        } else if (
          expense?.receipt?.isDistributed &&
          numerator !== 0 &&
          denominator !== 0
        ) {
          return total + prorate(amount, numerator, denominator)
        } else {
          return total + amount
        }
      }, 0)
    })

    const totalExpensesText = computed(() => {
      return `${totalExpenses.value.toLocaleString()}円`
    })

    const makeTransportationText = expense => {
      const from = expense?.from ?? ''
      const to = expense?.to ?? ''
      const type = expense?.type ?? []
      const isStation = type.length >= 1 ? type[0].id === 1 : false
      const isAirport = type.length >= 1 ? type[0].id === 3 : false
      const isCar = type.length >= 1 ? type[0].id === 2 : false
      if (!(isStation || isAirport || isCar)) {
        console.debug(`expense from or to is invalid. to: ${to}, from: ${from}`)
        return ''
      }
      let location = ''
      if (isStation) {
        location = '駅'
      } else if (isAirport) {
        location = '空港'
      }
      const roundTrip = expense.isRoundTrip ? ' [往復]' : ''
      return `${from}${location} 〜 ${to}${location}${roundTrip}`
    }

    const makeStayingText = expense => {
      const people = expense?.people ?? 0
      const stayingDays = expense?.stay_days ?? 0
      return `${people}人 / ${stayingDays}泊`
    }

    const prorate = (amount, numerator, denominator) => {
      return Math.floor((numerator * amount) / denominator)
    }

    /**
     * 数値に桁区切り+円をつけた文字列を返す\
     * 按分指定があれば按分した文字列を返す
     * 一部充当があれば一部充当金の文字列を返す
     *
     * @param {number} amount 金額
     * @param {bool} isPartial 一部充当フラグ
     * @param {number|null} partialAmount 一部充当金額
     * @param {bool} isDistributed 按分フラグ
     * @param {number|null} numerator 按分分子
     * @param {number|null} denominator 按分分母
     *
     * @returns string
     */
    const makeAmountText = (
      amount,
      isPartial,
      partialAmount,
      isDistributed,
      numerator = null,
      denominator = null,
    ) => {
      amount = amount ?? 0
      const amountWithComma = amount.toLocaleString()
      if (isPartial) {
        return `${partialAmount.toLocaleString()}円 [${amountWithComma}円一部充当]`
      } else if (isDistributed) {
        const proratedAmount = prorate(amount, numerator, denominator)
        const proratedStr = proratedAmount.toLocaleString()
        return `${amountWithComma}円 [${proratedStr}円 按分 ${numerator}/${denominator}]`
      } else {
        return `${amountWithComma}円`
      }
    }

    const makePaymentDateText = expenseDate => {
      if (typeof expenseDate !== 'string') {
        throw new Error('receipt expense date is invalid: ' + expenseDate)
      }
      const app = getCurrentInstance()
      const $filters = app.appContext.config.globalProperties.$filters
      const yearText = $filters.dateFormat(expenseDate)
      const wareki = $filters.wareki(expenseDate.replace(/-/g, '/'))
      return `${yearText} | ${wareki}`
    }

    const getExpenseData = (title, expense) => {
      const expenseData =
        title === '項目種別'
          ? expense.type[0].name
          : title === '経路'
          ? makeTransportationText(expense)
          : title === '人数'
          ? expense.people + '人'
          : title === '距離'
          ? expense.distance + 'Km'
          : title === '宿泊人数/日数'
          ? makeStayingText(expense)
          : title === '宿泊数'
          ? expense.stayDays ?? 0 + '日'
          : title === '1人あたりの料金'
          ? makeAmountText(expense?.amount)
          : title === '明細'
          ? expense.detail
          : title === '費目'
          ? expense.item
          : title === '宿泊詳細'
          ? expense.detail
          : title === '経費項目'
          ? actionTypeNames(currentPoliticalAction['selectedActionTypes'])
          : title === '支払額'
          ? makeAmountText(
              expense.receipt?.expenseAmount,
              expense.receipt?.isPartial,
              expense.receipt?.partialAmount,
              expense.receipt?.isDistributed,
              expense.receipt?.numerator,
              expense.receipt?.denominator,
            )
          : title === '支出年月日'
          ? makePaymentDateText(expense.receipt.expenseDate)
          : title === '支出内容'
          ? expense.receipt?.expenseContent1
          : title === '補記'
          ? expense.receipt?.expenseContent2
          : title === '債権者住所・氏名'
          ? expense.receipt?.creditorInfo
          : ''
      return expenseData
    }

    const downloadOrPreview = (file, receiptId) => {
      if (!file.display) {
        const url = URL.createObjectURL(file)
        if (
          file.type.startsWith('image/png') === true ||
          file.type.startsWith('image/jpeg') === true ||
          file.type.startsWith('application/pdf') === true
        ) {
          window.open(url, 'imgwindow')
        } else if (
          file.type.startsWith(
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          ) === true ||
          file.type.startsWith('application/vnd.ms-excel') === true ||
          file.type.startsWith(
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ) === true ||
          file.type.startsWith('application/msword') === true
        ) {
          const a = document.createElement('a')
          a.href = url
          a.download = file.name
          a.style.visibility = 'hidden'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      } else {
        // 一度保存されている添付資料はs3に保存されているためAPIからs3のパスを取得し処理を行う
        downloadOrPreviewFromS3(receiptId, 2, file, file.display)
      }
    }

    return {
      rejectHeaders,
      memoryOfficeMessage,
      currentPoliticalAction,
      rejectedAttrs,
      imgPreviewState,
      totalExpensesText,
      setRejectHeader,
      downloadOrPreviewFromS3,
      isImgZoomerOpen,
      openImgZoomer,
      imageIndex,
      expIndex,
      rejected,
      rejectToggleAttr,
      showReasonInput,
      onBlur,
      isShowImgPreview,
      makeProratedText,
      getExpenseData,
      downloadOrPreview,
      ...useDialog(),
      ...useMemoryForm(),
    }
  },
}
</script>

<style lang="scss" scoped>
.rejected-line {
  background: theme('colors.red.lightest');
  max-width: 665px;
}
td:first-child {
  border-top-left-radius: 22px;
  border-bottom-left-radius: 22px;
}
td:last-child {
  border-top-right-radius: 22px;
  border-bottom-right-radius: 22px;
}
</style>
